import React from "react";
import { map, size } from "lodash";
import styled from "styled-components";
import { Color } from "@glossy";
import { background, border, content, dominant } from "@glossy/theme";
import NavbarDropdown from "@komon/navigation/navbar/dropdown";
import { Locale } from "@linkfluence/models/locale";
import Button from "@ui-kit/button";
import Badge from "@ui-kit/chip/badge";
import Icon from "@ui-kit/icon";
import Tooltip from "@ui-kit/tooltip/description";
import Portrait from "@radarly/components/portrait/query";
import { tr } from "@radarly/i18n";

const StyledBadge = styled(Badge)`
  position: absolute;
  right: 4px;
  top: 4px;
`;

const Warmups = styled.div`
  color: ${content};
  background-color: ${background};
`;

const Title = styled.div`
  padding: 8px;
  font-weight: bold;
  border-bottom: 1px solid ${border};
  font-size: 16px;
`;

const Warmup = styled.div`
  padding: 8px;

  & + & {
    padding-top: 0;
  }
`;

const Caption = styled.span`
  margin-left: 4px;
  display: inline-block;
  vertical-align: middle;
  width: calc(100% - 36px);
`;

const Cancel = styled(Button)`
  margin-left: 12px;
`;

const Content = styled.div`
  white-space: nowrap;
`;

const Progress = styled.div`
  height: 8px;
  width: calc(100% - 64px);
  display: inline-block;
  border-radius: 8px;
  background-color: ${Color.VeryLightGrey};
  overflow: hidden;
`;

const ProgressBar = styled.div`
  height: 8px;
  border-radius: 8px;
  background-color: ${dominant};
`;

const Percent = styled.span`
  width: 24px;
  display: inline-block;
  text-align: right;
  margin-left: 4px;
`;

interface IProps {
  locale: Locale;
  onCancelWarmups: () => void;
  warmups: any;
  pullRight?: boolean;
}

const NavigationNavbarWarmups = ({
  warmups,
  onCancelWarmups,
  locale,
  pullRight,
}: IProps) => {
  const count = size(warmups);
  return (
    <NavbarDropdown
      pullRight={pullRight}
      toggle={
        <>
          <Icon glyph="arrows-spin" size="ms" />
          <StyledBadge color="info">{count}</StyledBadge>
        </>
      }
      menu={
        <Warmups>
          <Title>
            {tr(locale, "SETTINGS.SEARCHES.WARMUP.CURRENT_QUERIES", {
              count,
            })}
          </Title>
          {map(warmups, (warmup) => (
            <Warmup key={warmup.id}>
              <div>
                <Portrait picture={warmup.picture} size="s" />
                <Tooltip content={warmup.label}>
                  <Caption>{warmup.label}</Caption>
                </Tooltip>
              </div>
              <Content>
                <Progress>
                  <ProgressBar style={{ width: warmup.percent + "%" }} />
                </Progress>
                <Percent>{warmup.percent + "%"}</Percent>
                <Cancel
                  variant="danger"
                  size="s"
                  circular
                  icon="cross"
                  onClick={onCancelWarmups}
                />
              </Content>
            </Warmup>
          ))}
        </Warmups>
      }
    />
  );
};

export default NavigationNavbarWarmups;
